import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Import } from "iconsax-react";
import { Button, Dropdown, DropdownItem } from "@/shared/ui";

interface ExportDropdownProps {
  onExportTasks: () => void;
  onExportAudit: () => void;
}

export default function ExportDropdown({ onExportTasks, onExportAudit }: ExportDropdownProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("TasksPage");
  return (
    <Dropdown open={open} onClose={() => setOpen(false)} align="right">
      <Button
        variant="secondary"
        size="lg"
        className="w-9! h-9! p-0! flex radius-xs! justify-center items-center content-base-secondary"
        onClick={() => setOpen(!open)}>
        <Import size={20} color="currentColor" />
      </Button>
      <DropdownItem
        onClick={() => {
          onExportTasks();
          setOpen(false);
        }}>
        {t("export.optionTasks")}
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          onExportAudit();
          setOpen(false);
        }}>
        {t("export.optionAudit")}
      </DropdownItem>
    </Dropdown>
  );
}
